module.exports = __webpack_public_path__ + "static/img/ARCHER-MAY.24af153.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ARCHER-MAY.jpg
// module id = 7AX4
// module chunks = 0